import { Spacing40, Spacing16, Spacing24, Spacing32, FontSize12 } from 'autogen/design-tokens/tokens';
import { DonationModel } from 'autogen/swagger/all';
import React from 'react';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import Header from './header';
import OptionList from './optionList';

const Wrapper = styled.div`
    padding: ${Spacing24} ${Spacing16};

    ${breakpoint.up(sizes.md)} {
        flex: 0 1 100%;
    }

    ${breakpoint.up(sizes.lg)} {
        padding: ${Spacing32} ${Spacing40};
    }
`;

const CompletedMessage = styled.div`
    margin-bottom: ${Spacing16};
    font-weight: bold;

    ${breakpoint.up(sizes.md)} {
        margin-bottom: ${Spacing24};
    }
`;

const SubText = styled.p`
    margin-bottom: 0;
    font-size: ${FontSize12};
`;

interface ITextContainer {
    texts: DonationModel['texts'];
    options: DonationModel['options'];
    completedMessage: DonationModel['completedMessage'];
    isCompleted: DonationModel['isCompleted'];
}

export default function TextContainer({ texts, options, completedMessage, isCompleted }: ITextContainer): JSX.Element {
    const { heading, subHeading, subText } = texts;

    return (
        <Wrapper>
            <Header headline={heading} subHeadline={subHeading} />
            {isCompleted && completedMessage ? (
                <CompletedMessage>{completedMessage}</CompletedMessage>
            ) : (
                <OptionList donationOptions={options} />
            )}
            <SubText dangerouslySetInnerHTML={{ __html: subText }} />
        </Wrapper>
    );
}
